module.exports = __webpack_public_path__ + "img/icon-arrow-up-20@2x.87c66e07.png";